<template>
  <div>
    <el-button type="success" class="submit-btn" style="width: 100%" @click="click">{{
      text
    }}</el-button>
  </div>
</template>

<script>
export default {
  name: "SubmitBtn",
  props: {
    text: {
      defalut: "提交",
    },
  },
  data() {
    return {
      // state
    };
  },

  methods: {
    // method
    click() {
      this.$emit('click')
    }
  },
};
</script>

<style lang="scss" scoped>
.submit-btn {
  width: 420px;
  background-color: #fe5a13;
  border: 0;
  height: 60px;
  font-size: 20px;
}

.submit-btn:hover {
  background-color: #f57138;
}
</style>
